export default "__VITE_ASSET__DUyFPkp___"